import produce from "immer";
import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../actions/elementListAction";
import { Element } from "../../../models/elementModel";
import ImageUploading, { ImageListType } from "react-images-uploading";
import { defaultImg } from "../../../utils/constants";
import { ImageModel } from "../../../models/imageModel";
import './elementProprtiesPanal.scss';
import imageService from "../../../services/imageService";
import Switch from "react-switch";


export interface ImageElementPropertiesProps {
  element: Element;
}
const ImageProperties: FC<ImageElementPropertiesProps> = ({
  element,
}) => {
  const dispatch = useDispatch();
  const [images, setImages] = React.useState([]);
  const maxNumber = 1;
  const removeImg = ()=>{
    const newElement = produce(element, draft => { draft.properties.imageUrl = defaultImg})
    dispatch(startEditElement(newElement));
  }
  const onChange = async (
    imageList: ImageListType,
    addUpdateIndex: number[] | undefined
  ) => {
    console.log(imageList, addUpdateIndex);
    let img_type = imageList[0].file?.type.split('/')[1].toLowerCase();
    let imgString = imageList[0].data_url.split('base64,')[1]
    setImages(imageList as never[]);
    let imageUploadModel: ImageModel = {image:imgString,imageType:`${img_type}`};

    const { data } = await imageService.saveImage({image: imageUploadModel});
    console.log(data.data);
    const newElement = produce(element, draft => {
      draft.properties.imageUrl = data.data;
    })

    dispatch(startEditElement(newElement));
    // console.log(imgString)
  };
return (
    <div className="container mt-3">
      <div className="form-group row">
        <label htmlFor="elementName" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Name
        </label>
        <div className="col-sm-8">
          <input
            value={`${element.name}`}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.name = e.target.value})
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="elementName"
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="img-alt" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Image ALT
        </label>
        <div className="col-sm-8">
          <input
            value={element.properties.alt}
            className="form-control theam-textbox items-align-left"
            onChange={(e) => {
              const newElement = produce(element, draft => { draft.properties.alt = e.target.value})
              dispatch(startEditElement(newElement));
            }}
            type="text"
            id="img-alt"
          />
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="btn-outline" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Display
        </label>
          <div className="col-sm-2 mt-1">
            <Switch
              checked={element.properties.display}
              onChange={() =>{
                const newElement = produce(element, draft => {
                  draft.properties.display = !draft.properties.display;
                })
                dispatch(startEditElement(newElement));
              }}
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={10}
              width={24}
              className="react-switch"
              id="btn-outline"
             />
          </div>
      </div>
      <div className="form-group row">
        <label htmlFor="tooltip" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Tooltip
        </label>
          <div className="col-sm-8">
            <textarea className="form-control theam-textbox font-size-12 items-align-left" name="tooltip" id="tooltip"     placeholder="Enter tooltip" cols={30} rows={2}
            value={element.properties.tooltip}
              onChange={(e) => {
                const newElement = produce(element, draft => { draft.properties.tooltip = e.target.value})
                dispatch(startEditElement(newElement));
              }}
            ></textarea>
        </div>
      </div>
      <div className="form-group row">
        <label htmlFor="link" className="col-sm-4 col-form-label font-size-12 align-text-left">
          Link
        </label>
          <div className="col-sm-8">
            <textarea className="form-control theam-textbox font-size-12 items-align-left" name="link" id="link" placeholder="Enter Alredy Uploaded Image Link" cols={30} rows={2}
            value={element.properties.imageUrl}
              onChange={(e) => {
                const newElement = produce(element, draft => { draft.properties.imageUrl = e.target.value})
                dispatch(startEditElement(newElement));
              }}
            ></textarea>
        </div>
      </div>
      <ImageUploading
        // multiple
        maxFileSize={5242880}
        value={images}
        onChange={onChange}
        // maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          <div className="upload__image-wrapper">
              <div className="form-group row">
                <div className="col-12">
                  <button className="btn btn-dark btn-theam btn-lg btn-block ml-3 font-size-12" style={isDragging ? { color: 'red' } :undefined} onClick={onImageUpload} {...dragProps}>Click or Drop here </button>
                </div>
              </div>
            &nbsp;
            <div key={element.properties.id} className="image-item mb-2">
                {/* <img src={element.properties.imageUrl} alt="" width="100" /> */}
                <img src={element.properties.imageUrl} alt="" width="100" />
            </div>
            &nbsp;
            <div className="form-group row">
              <div className="col-12">
                <button className="btn btn-theam btn-dark btn-lg btn-block ml-3 font-size-12" onClick={removeImg}>Remove Upload</button>
              </div>
            </div>
          </div>
        )}
      </ImageUploading>
    </div>
  );
};

export default ImageProperties;
